import React, { useMemo } from "react";
import "./index.scss";
import DateBox from "devextreme-react/date-box";
import { IMdaeDateBoxOption } from "./index";
import {
  DX_WIDGET_NAMES,
  configureMdaeWidgetOptionUpdaters,
} from "../../mdae-framework";
import { useDispatch } from "react-redux";
import { RequiredFieldLabel } from "../required-field-label";

const transformDate = (date) => {
  date = new Date(date);
  var year = date.getFullYear();
  var month = (1 + date.getMonth()).toString();
  month = month.length > 1 ? month : "0" + month;
  var day = date.getDate().toString();
  day = day.length > 1 ? day : "0" + day;
  return month + "/" + day + "/" + year;
};
const tranformStringDate = (date) => {
  if (date) {
    if (date != "") {
      date = transformDate(new Date(date));
    }
  }
  return date;
};
const defaultDateDisplayFormat = {
  formatter: (e) => {
    return tranformStringDate(e);
  },
  parser: (e) => {
    return new Date(tranformStringDate(e));
  },
};

const MdaeDateBox: React.FC<IMdaeDateBoxOption> = (props) => {
  const dispatch = useDispatch();
  const getDefaultDisplayFormat = useMemo(() => {
    return (
      props.displayFormat ||
      (props.type === "time" || props.type === "datetime"
        ? null
        : defaultDateDisplayFormat)
    );
  }, [props.displayFormat, props.type]);
  return (
    <div className={"sys-mdae-date-box-container"}>
      <DateBox
              {...props}
              onInitialized={(e) => {
                  if (typeof props.onInitialized === "function") props.onInitialized(e);
                  configureMdaeWidgetOptionUpdaters(
                      props.mdaeDataUpdaterConfig,
                      DX_WIDGET_NAMES.DX_DATE_BOX,
                      e.component,
                      dispatch
                  );
              }}
              displayFormat={getDefaultDisplayFormat}
              useMaskBehavior={true}
      ></DateBox>
      {props.visible !== false && (
        <span className={"mdae-text-box-field-set-text"}>
          {props.mdaeDateBoxTitle}
          {props.required && <RequiredFieldLabel />}
        </span>
      )}
    </div>
  );
};
export default MdaeDateBox;
